import { Snackbar } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import userApi from '../../api/userApi';
import {
  StyledContainer,
  StyledFieldSet,
  StyledFieldSetTitle,
  StyledForm,
  StyledFormCard,
  StyledFormField,
  StyledFormInner,
  StyledHeader,
  StyledSubmitButton,
} from './styled';

interface CreateAppError {
  data: {
    error_description: string;
  };
}

const NewApp = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [isSnackbarShown, setIsSnackbarShown] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState<string | null>(null);

  const [createApp] = userApi.useCreateAppMutation();

  const showErrorSnackbar = (message: string) => {
    setSnackbarMessage(message);
    setIsSnackbarShown(true);
  };

  const formActionHandler = async (formData: FormData) => {
    setIsLoading(true);

    try {
      const { apikey } = await createApp(formData).unwrap();
      localStorage.setItem(
        'TryIt_securitySchemeValues',
        `{"apikey":"${apikey}"}`
      );
      navigate('/apps');
    } catch (error) {
      const description = (error as CreateAppError).data.error_description;
      showErrorSnackbar(description);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={isSnackbarShown}
        autoHideDuration={6000}
        onClose={() => setIsSnackbarShown(false)}
        message={snackbarMessage}
      />
      <StyledContainer>
        <StyledFormCard>
          <StyledForm action={formActionHandler}>
            <StyledFormInner>
              <StyledFieldSet>
                <StyledHeader>Create App</StyledHeader>
                <StyledFieldSetTitle>App details</StyledFieldSetTitle>
                <StyledFormField name="name" required label="App Name" />
                <StyledFormField
                  name="description"
                  required
                  label="Description"
                />
                <StyledFormField name="website" required label="Website" />
              </StyledFieldSet>
            </StyledFormInner>

            <StyledSubmitButton
              loading={isLoading}
              variant="outlined"
              type="submit"
            >
              Create App
            </StyledSubmitButton>
          </StyledForm>
        </StyledFormCard>
      </StyledContainer>
    </>
  );
};

export default NewApp;
